export const ACTION_CLASSES = {
  CREATE: 'text-green-500 dark:text-green-500',
  DELETE: 'text-red-500 dark:text-red-500 line-through',
  REJECT: 'text-red-500 dark:text-red-500',
  UPDATE: 'text-blue-500 dark:text-blue-500',
};

export type ActionClass = keyof typeof ACTION_CLASSES;

export const IGNORED_FIELDS = [
  'template',
  'uuid',
  'createdAt',
  'createdBy',
  'lastModifiedAt',
  'clinicalNotes',
  'lastModifiedBy',
  'templateUuid',
  'reportUuid',
  'reportFindingsUuids',
  'publishedAt',
  'publishedBy',
  'report',
  'authors',
  'studyId',
  'excludeDicomImages',
  'observation',
  'additionalRecommendations',
  'reportFindings',
  'clinicalNotes',
  'renderedSummaryUuid',
  'userSession',
  'verifyHash',
  'aiFindings',
];

export const EDITOR_FIELDS = [
  'descriptionOfCall',
  'techniqueNotes',
  'actionDetails',
  'actionSummary',
  'findingDetails',
  'findingSummary',
  'finalImpressions',
];

export const ACTIVITY_LOG_DEFAULT_VALUES = {
  false: 'No',
  no_previous: 'No previous value',
  true: 'Yes',
};

export const RELATED_OBJECT_TYPE = 'Report';
